module.exports = __webpack_public_path__ + "img/lock-icon.22e6f70d.svg";